import {AccountSummaryReportModel} from "./account-summary-report.model";
import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {Plugin} from "../../../config";

@Component({
    selector: "wbo-account-summary-report",
    templateUrl: "./account-summary-report.component.html",
    providers: [provideReportModel(AccountSummaryReportModel)]
})
export class AccountSummaryReportComponent extends AbstractReportPage {
    Plugin = Plugin;

    constructor(public model: AccountSummaryReportModel) {
        super();
    }
}
